<template>
  <button
    :class="$style.link"
    @click="handleClick"
  >
    <!-- This is to remove extra space at end of links -->
    <!-- eslint-disable-next-line vue/multiline-html-element-content-newline -->
    {{ text }}</button>
</template>

<script>
export default {
  name: 'ButtonLink',

  props: {
    text: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style module>
/* @todo These colors need to be replaced with brand colors
when anchor styles are updated */
button.link {
  background: none;
  color: #337ab7;
  padding: 0;
}

.link:hover {
  color: #23527c;
  text-decoration: underline;
}
</style>
